<div class="revision-container">
  <h3>{{title}}</h3>

  <div class="main-content">
    <div class="revision-sidebar">
      <mat-selection-list [multiple]="false" hideSingleSelectionIndicator>
        <div mat-subheader>Revisions</div>
        <mat-list-option *ngFor="let revision of revisions" [value]="revision" (click)="showRevision(revision)">
          <span matListItemTitle>{{revision.endDate | date:'d-M-y HH:mm'}}</span>
        </mat-list-option>
      </mat-selection-list>
    </div>

    <div class="revision-viewer">
      <div [innerHTML]="editorData" class="content-display"></div>
    </div>
  </div>

  <div class="actions">
    <button mat-raised-button color="primary" type="button" (click)="close()">Close</button>
  </div>
</div>